/**
 * CompletionRing — fixed-size SVG ring showing the overall structured
 * care plan completion percentage. Drives the eye toward unfinished
 * sections without competing with the section body for attention.
 */
import React from 'react';

export function CompletionRing({ pct = 0, size = 56 }) {
  const stroke = 6;
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, pct));
  const offset = circumference - (clamped / 100) * circumference;
  const ringColor = clamped >= 80 ? '#10b981' : clamped >= 40 ? '#f59e0b' : '#ef4444';
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="structured-completion-ring">
      <svg width={size} height={size} className="rotate-[-90deg]">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e4e4e7"
          strokeWidth={stroke}
          fill="transparent"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={ringColor}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
          fill="transparent"
          style={{ transition: 'stroke-dashoffset 0.4s ease, stroke 0.4s ease' }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center text-xs font-bold tabular-nums"
           data-testid="structured-completion-ring-pct">
        {clamped}%
      </div>
    </div>
  );
}

export default CompletionRing;
